import { translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { IconName } from 'aos-ui-universal/src/icons/compiled'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'

import { taskProcessType } from '../../flightInformation/types/AosAirport'

export enum TaskProcessType {
    Daily = 'DAILY',
    Seasonal = 'SEASONAL',
    DailyTerminal = 'DAILY_TERMINAL',
    AutomatedVehicleTask = 'AUTOMATED_VEHICLE_TASK',
}

export const taskProcessTypes = taskProcessType
export const allTaskProcessTypes = EnumValues.getValues(TaskProcessType)

export const translateTaskProcessType = (t: TFunction) =>
    translateEnum(t)(TaskProcessType, 'task-process-type')

export const taskProcessTypeIconsMobile: Record<TaskProcessType, IconName> = {
    [TaskProcessType.AutomatedVehicleTask]: 'TaskProcessAutomatedVehicle',
    [TaskProcessType.Seasonal]: 'TaskProcessSeasonal',
    [TaskProcessType.Daily]: 'TaskProcessDailyMaintenance',
    [TaskProcessType.DailyTerminal]: 'TaskProcessDailyTerminal',
}
